export const getWarningMessege = (warning:string) =>{
    if(warning.length === 0) return '';
    switch (warning) {
        case 'Use a few words, avoid common phrases':
            return 'いくつかの単語を組み合わせて、一般的なフレーズを避けてください';
        case 'No need for symbols, digits, or uppercase letters':
            return '記号、数字、または大文字は不要です';
        case 'Add another word or two. Uncommon words are better.':
            return '別の単語を追加してください。 一般的でない言葉が良いです';
        case 'Straight rows of keys are easy to guess':
            return '直線のキー列は推測しやすいです';
        case 'Short keyboard patterns are easy to guess':
            return '短いキーボードパターンは推測しやすいです';
        case 'Repeats like "aaa" are easy to guess':
            return '"aaa"のような繰り返しは推測しやすいです';
        case 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"':
            return '"abcabcabc"のような繰り返しは推測しやすいです';
        case 'Sequences like abc or 6543 are easy to guess':
            return 'abcや6543のような文字の羅列は簡単に推測できます';
        case 'Recent years are easy to guess':
            return '近年は推測しやすいです';
        case 'Dates are often easy to guess':
            return '日付は比較的推測しやすいです';
        case 'This is a top-10 common password':
            return 'これはトップ10に入る一般的なパスワードです';
        case 'This is a top-100 common password':
            return 'これはトップ100に入る一般的なパスワードです';
        case 'This is a very common password':
            return 'これはとても一般的なパスワードです';
        case 'This is similar to a commonly used password':
            return 'これはよく使われるパスワードに似ています';
        case 'Names and surnames by themselves are easy to guess':
            return '名前と姓は簡単に推測できます';
        case 'Common names and surnames are easy to guess':
            return '一般名と姓は簡単に推測できます';
        case 'A word by itself is easy to guess':
            return '単語単体での推測は簡単です';
        default:
            return 'パスワードの強度が足りません';
    }
}